"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[206],{

/***/ 1255:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ block_content; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(4184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@sanity/block-content-to-react/lib/BlockContent.js
var BlockContent = __webpack_require__(8863);
var BlockContent_default = /*#__PURE__*/__webpack_require__.n(BlockContent);
// EXTERNAL MODULE: ./components/photo.js
var photo = __webpack_require__(727);
// EXTERNAL MODULE: ./components/link.js + 1 modules
var components_link = __webpack_require__(8250);
;// CONCATENATED MODULE: ./components/block-serializers.js






function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var blockSerializers = {
    types: {
        block: function(props) {
            var _node = props.node, markDefs = _node.markDefs, _style = _node.style, style = _style === void 0 ? "normal" : _style;
            // check if our block contains a button
            var hasButton = markDefs && markDefs.some(function(c) {
                return c._type === "link" && c.isButton === true;
            });
            // build our mock header styles
            if (style === "h1mock") {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: classnames_default()("text-h1", {
                        "has-btn": hasButton
                    }),
                    children: props.children
                }));
            }
            if (style === "h2mock") {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: classnames_default()("text-h2", {
                        "has-btn": hasButton
                    }),
                    children: props.children
                }));
            }
            if (style === "h3mock") {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: classnames_default()("text-h3", {
                        "has-btn": hasButton
                    }),
                    children: props.children
                }));
            }
            if (style === "h4mock") {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: classnames_default()("text-h4", {
                        "has-btn": hasButton
                    }),
                    children: props.children
                }));
            }
            if (style === "h5mock") {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: classnames_default()("text-h5", {
                        "has-btn": hasButton
                    }),
                    children: props.children
                }));
            }
            if (style === "h6mock") {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: classnames_default()("text-h6", {
                        "has-btn": hasButton
                    }),
                    children: props.children
                }));
            }
            if (style === "large") {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: classnames_default()("text-lg-3-mobile", "md:text-lg-3", {
                        "has-btn": hasButton
                    }),
                    children: props.children
                }));
            }
            if (style === "subheadLarge") {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: classnames_default()("text-subhead-large", {
                        "has-btn": hasButton
                    }),
                    children: props.children
                }));
            }
            if (style === "subheadMedium") {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: classnames_default()("text-subhead-medium", {
                        "has-btn": hasButton
                    }),
                    children: props.children
                }));
            }
            if (style === "subheadSmall") {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: classnames_default()("text-subhead-small", {
                        "has-btn": hasButton
                    }),
                    children: props.children
                }));
            }
            if (style === "paragraphLarge") {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: classnames_default()("text-large font-sansRegular", {
                        "has-btn": hasButton
                    }),
                    children: props.children
                }));
            }
            if (style === "paragraphMedium") {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: classnames_default()("text-medium", {
                        "has-btn": hasButton
                    }),
                    children: props.children
                }));
            }
            if (style === "caption") {
                return(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: classnames_default()("text-caption", {
                        "has-btn": hasButton
                    }),
                    children: props.children
                }));
            }
            // go through our remaing, true header styles
            if (/^h\d/.test(style)) {
                return(/*#__PURE__*/ react.createElement(style, {
                    className: hasButton ? "has-btn" : null
                }, props.children));
            }
            // handle all other blocks with the default serializer
            return BlockContent_default().defaultSerializers.types.block(props);
        },
        photo: function(param) {
            var node = param.node;
            return(/*#__PURE__*/ (0,jsx_runtime.jsx)(photo/* default */.Z, {
                photo: node
            }));
        },
        horizontalRule: function() {
            /*#__PURE__*/ return (0,jsx_runtime.jsx)("hr", {});
        }
    },
    marks: {
        link: function(param) {
            var mark = param.mark, children = param.children;
            var title = children[0];
            return(/*#__PURE__*/ (0,jsx_runtime.jsx)(components_link/* default */.Z, {
                link: _objectSpread({}, mark, {
                    title: title
                })
            }));
        }
    }
};

;// CONCATENATED MODULE: ./components/block-content.js





var Content = function(param) {
    var blocks = param.blocks, className = param.className;
    if (!blocks) return null;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)((BlockContent_default()), {
        renderContainerOnSingleChild: true,
        className: classnames_default()("rc", className),
        blocks: blocks,
        serializers: blockSerializers
    }));
};
/* harmony default export */ var block_content = (Content);


/***/ }),

/***/ 4206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7627);
/* harmony import */ var _components_photo__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(727);
/* harmony import */ var _components_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8250);
/* harmony import */ var _components_block_content__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1255);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6513);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(6139);
/* harmony import */ var react_cool_inview__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5276);









var IntroText = function(param1) {
    var _data = param1.data, data = _data === void 0 ? {} : _data;
    var style = data.style, text = data.text, cta = data.cta, pricingBlocks = data.pricingBlocks, pricingAdditionalText = data.pricingAdditionalText, backgroundColor = data.backgroundColor, image = data.image, removeMinHeight = data.removeMinHeight;
    var controls = (0,framer_motion__WEBPACK_IMPORTED_MODULE_8__/* .useAnimation */ ._)();
    var rootMargin =  true ? "".concat(window.outerHeight * -0.4, "px 0px") : 0;
    var ref1 = (0,react_cool_inview__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)({
        threshold: 0,
        rootMargin: rootMargin,
        onEnter: function(param) {
            var scrollDirection = param.scrollDirection, entry = param.entry, observe = param.observe, unobserve = param.unobserve;
            if (scrollDirection.vertical == "up") {
                controls.start("visible");
            }
        }
    }, [
        controls
    ]), observe = ref1.observe, unobserve = ref1.unobserve, inView = ref1.inView, scrollDirection1 = ref1.scrollDirection, entry = ref1.entry;
    if (inView) {
        controls.start("visible");
    }
    var lineVariants = {
        visible: {
            opacity: 1,
            width: "50px",
            transition: {
                duration: 1
            }
        },
        hidden: {
            opacity: 1,
            width: "0px",
            transition: {
                duration: 1
            }
        }
    };
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("intro-text", "bg-".concat(backgroundColor.value), {
            "min-h-screen": !removeMinHeight
        }),
        "data-theme": backgroundColor === null || backgroundColor === void 0 ? void 0 : backgroundColor.title.toLowerCase(),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("site-container--disabled"),
            children: [
                style == "withPricingBlocks" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("grid", "grid-cols-4", "md:grid-cols-20", "p-gutter", "py-20", "text-left", {
                        "gap-5": pricingBlocks
                    }),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("col-span-4", "pl-[8px]", {
                                "md:col-span-14": !pricingBlocks,
                                "md:col-span-12": pricingBlocks
                            }),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_9__.m.div, {
                                    ref: observe,
                                    initial: "hidden",
                                    variants: lineVariants,
                                    animate: controls,
                                    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("border-t", "w-[50px]", "mb-8", {
                                        hidden: image
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("text-lg-2-mobile", "md:text-lg-2"),
                                    children: text
                                })
                            ]
                        }),
                        pricingBlocks && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("col-span-4", "md:col-span-7", "md:col-start-14", "mt-10"),
                            children: [
                                pricingBlocks.map(function(block, idx) {
                                    var ref;
                                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("pricing-block", "px-4", "py-6", "bg-".concat(block.backgroundColor.value)),
                                        "data-theme": (ref = block.backgroundColor) === null || ref === void 0 ? void 0 : ref.title.toLowerCase(),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("text-subheader-2", "uppercase", "font-sansRegular"),
                                                children: block.label
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("text-lg-2-mobile", "md:text-lg-2"),
                                                children: block.value
                                            })
                                        ]
                                    }, idx);
                                }),
                                pricingAdditionalText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("px-4", "py-6", "text-caption", "font-sansRegular"),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_block_content__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                        blocks: pricingAdditionalText
                                    })
                                })
                            ]
                        })
                    ]
                }),
                style == "withDecorativeImage" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("grid", "grid-cols-4", "md:grid-cols-20", "text-left", "p-gutterInset"),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("col-span-4", "md:col-span-14", "py-20"),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_9__.m.div, {
                                        ref: observe,
                                        initial: "hidden",
                                        variants: lineVariants,
                                        animate: controls,
                                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("border-t", "w-[50px]", "mb-8")
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("text-lg-2-mobile", "md:text-lg-2"),
                                        children: text
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("grid", "grid-cols-4", "md:grid-cols-20", "text-left", "mt-10"),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("col-span-2", "col-start-3", "md:col-span-6", "md:col-start-15"),
                                children: image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("col-span-4", "md:col-span-10"),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_photo__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                        photo: image,
                                        width: 1200,
                                        layout: "intrinsic"
                                    })
                                })
                            })
                        })
                    ]
                }),
                style == "default" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("p-gutter"),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("grid", "grid-cols-4", "sm:grid-cols-20", "text-left", "bg-white", "rounded-[3px]", "gap-5", "p-gutter"),
                                children: [
                                    image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("col-span-4", "sm:col-span-10", "order-last", "sm:order-first"),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_photo__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                            photo: image,
                                            width: 1200,
                                            layout: "intrinsic"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("col-span-4", {
                                            "sm:col-span-14 py-20": !image,
                                            "sm:col-span-10": image
                                        }),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("h-full"),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_9__.m.div, {
                                                    ref: observe,
                                                    initial: "hidden",
                                                    variants: lineVariants,
                                                    animate: controls,
                                                    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("border-t", "w-[50px]", "mb-8", {
                                                        hidden: image
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("text-lg-2-mobile", "md:text-lg-2"),
                                                    dangerouslySetInnerHTML: {
                                                        __html: text.replace(/(?:\r\n|\r|\n)/g, "<br/>")
                                                    }
                                                }),
                                                cta && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_link__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                    className: "cta-link mt-5",
                                                    link: cta[0]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        }),
                        !image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("grid", "grid-cols-4", "md:grid-cols-20", "text-left", {
                                "gap-5": image,
                                "p-gutterInset": !image,
                                "p-gutter": image
                            }),
                            children: [
                                image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("col-span-4", "md:col-span-10"),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_photo__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                        photo: image,
                                        width: 1200,
                                        layout: "intrinsic"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("col-span-4", {
                                        "md:col-span-14 py-20": !image,
                                        "md:col-span-6": image
                                    }),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("h-full"),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_9__.m.div, {
                                                ref: observe,
                                                initial: "hidden",
                                                variants: lineVariants,
                                                animate: controls,
                                                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("border-t", "w-[50px]", "mb-8", {
                                                    hidden: image
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("text-lg-2-mobile", "md:text-lg-2"),
                                                dangerouslySetInnerHTML: {
                                                    __html: text.replace(/(?:\r\n|\r|\n)/g, "<br/>")
                                                }
                                            }),
                                            cta && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_link__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                className: "cta-link mt-5",
                                                link: cta[0]
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (IntroText);


/***/ })

}]);